import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'
import { myAccountModalHide } from 'Global/Stores/modals'
import { passwordChange } from 'Global/Stores/auth'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    hasError: selectors.hasError(state),
    isPending: selectors.isPending(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    close: () => dispatch(myAccountModalHide()),
    changePassword: (oldPassword, newPassword, userId) => dispatch(passwordChange(oldPassword, newPassword, userId)),
  })

  Enhancer.displayName = 'MyAccountModalEnhancer'

  Enhancer.propTypes = {
    changePassword: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    hasError: PropTypes.bool.isRequired,
    isPending: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
